(function(){
  function ready(fn){if(document.readyState!='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}

  var clockIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>';
  var truckIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h11v10H3zM14 11h4l3 3v3h-7z"/><circle cx="7" cy="19" r="1.6"/><circle cx="18" cy="19" r="1.6"/></svg>';
  var pinIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7-7.5-7-12a7 7 0 1114 0c0 4.5-7 12-7 12z"/><circle cx="12" cy="9" r="2.5"/></svg>';

  var LEAD_TIME_MAP={
    '1day': {label:'24 Hour Lead', tooltip:'Order by 5:00pm CST (3:00pm CST on Fridays)'},
    '2day': {label:'2 Day Lead', tooltip:'Order by 3:00pm CST'},
    '3day': {label:'3 Day Lead', tooltip:'Order by 3:00pm CST'},
    '4day': {label:'4 Day Lead', tooltip:'Order by 3:00pm CST'},
    '5day': {label:'5 Day Lead', tooltip:'Order by 3:00pm CST'},
    '7day': {label:'7 Day Lead', tooltip:'Order by 3:00pm CST'},
    '14day': {label:'14 Day Lead', tooltip:'Order by 3:00pm CST'}
  };
  var LEAD_TIME_ORDER=['1day','2day','3day','4day','5day','7day','14day'];

  function initLeadTimeBadge(){
    var tagsEl=document.getElementById('ttc-product-tags');
    if(!tagsEl)return;
    var tags=[];
    try{tags=JSON.parse(tagsEl.textContent)||[];}catch(e){return;}
    var normalized=tags.map(function(t){return String(t).toLowerCase().replace(/\s+/g,'');});
    var match=null;
    for(var i=0;i<LEAD_TIME_ORDER.length;i++){
      if(normalized.indexOf(LEAD_TIME_ORDER[i])>-1){match=LEAD_TIME_MAP[LEAD_TIME_ORDER[i]];break;}
    }
    if(!match)return;
    var titleEl=document.querySelector('.title-row');
    var anchor=titleEl||document.querySelector('.price-container');
    if(!anchor)return;
    var badge=document.createElement('div');
    badge.className='ttc-lead-badge';
    badge.setAttribute('tabindex','0');
    badge.setAttribute('data-tooltip',match.tooltip);
    badge.innerHTML=clockIcon+'<span>'+match.label+'</span>';
    anchor.insertAdjacentElement('afterend',badge);
  }

  function initTrustRow(){
    var addToCart=document.querySelector('.add-to-cart');
    if(!addToCart)return;
    var inputRow=addToCart.closest('.input-row');
    if(!inputRow)return;
    var row=document.createElement('div');
    row.className='ttc-trust-row';
    row.innerHTML=
      '<span class="ttc-trust-item">'+clockIcon+'<span>Made To Order</span></span>'+
      '<span class="ttc-trust-item">'+truckIcon+'<span>DFW Delivery</span></span>'+
      '<span class="ttc-trust-item">'+pinIcon+'<span>In-Store Pickup</span></span>';
    inputRow.insertAdjacentElement('afterend',row);
  }

  ready(function(){
    if(document.body.classList.contains('template-product')){
      initLeadTimeBadge();
      initTrustRow();
    }
  });
})();
